import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useVehicleTypeList() {
  // Use toast
  const toast = useToast()

  const refVehicleTypeListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'description', label: 'Description', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(100)
  const totalVehicleTypes = computed(() => store.state['app-vehicle-type'].total)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(false)

  const vehicleTypes = computed(() => store.state['app-vehicle-type'].vehicleTypes)

  const dataMeta = computed(() => {
    const localItemsCount = refVehicleTypeListTable.value ? refVehicleTypeListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalVehicleTypes.value,
    }
  })

  const refetchData = () => {
    fetchVehicleTypes()
    refVehicleTypeListTable.value.refresh()
  }

  watch([currentPage, perPage, sortBy, isSortDirDesc, searchQuery], () => {
    refetchData()
  })

  const fetchVehicleTypes = () => {
    store
      .dispatch('app-vehicle-type/fetchVehicleTypes', {
        limit: perPage.value,
        page: currentPage.value,
        sort: `vt.${sortBy.value}`,
        direction: isSortDirDesc.value ? 'desc' : 'asc',
      })
      .catch((err) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching vehicle types',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchVehicleTypes,
    tableColumns,
    perPage,
    currentPage,
    totalVehicleTypes,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refVehicleTypeListTable,
    refetchData,
    vehicleTypes
  }
}